import { render } from "./Locations.vue?vue&type=template&id=0334a18d&scoped=true&ts=true"
import script from "./Locations.vue?vue&type=script&lang=ts"
export * from "./Locations.vue?vue&type=script&lang=ts"

import "./Locations.vue?vue&type=style&index=0&id=0334a18d&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0334a18d"]])

export default __exports__